
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.542.833a.833.833 0 00-1.667 0v6.042H.833a.833.833 0 000 1.667h6.042v6.041a.833.833 0 101.667 0V8.542h6.041a.833.833 0 100-1.667H8.542V.833z","fill":"#282E3E"}})])
          )
        }
      }
    